import React, { useEffect } from "react";
import { IntlProvider } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import { Outlet } from "react-router-dom";

import Loading from "./components/common/Loading";
import { GeneralModal } from "./containers/GeneralModalContainer";
import { getAppData } from "./modules/settings/slices/settings.actions";
import { getThemeVariables } from "./utils/theme";
import "./scss/index.scss";

export const Layout = (props) => {
	const dispatch = useDispatch();

	const appReady = useSelector((state) => state.settings.appReady);
	const storeId = useSelector((state) => state.settings.storeId);
	const strings = useSelector((state) => state.settings.strings);
	const locale = useSelector((state) => state.settings.locale);

	const dest = document.getElementById("app");

	const getInitalModel = () => {
		const model = dest.parentNode.getAttribute("data-model");
		const tokenData = document.querySelector("#antiForgeryTokenData");
		if (model) {
			const parsedModel = JSON.parse(model);
			if (tokenData && parsedModel) {
				parsedModel.token = {
					header: tokenData.getAttribute("data-header-name"),
					value: tokenData.getAttribute("data-token"),
				};
			}

			return parsedModel;
		}

		return {};
	};

	const { mainColor, primaryBackgroundHover, primaryBackgroundActive } =
		getThemeVariables(storeId);

	useEffect(() => {
		if (appReady) {
			document.documentElement.style.setProperty("--main-color", mainColor);
			document.documentElement.style.setProperty(
				"--button-primary-background-hover",
				primaryBackgroundHover,
			);
			document.documentElement.style.setProperty(
				"--button-primary-background-active",
				primaryBackgroundActive,
			);
		}
	}, [appReady]);

	useEffect(() => {
		dispatch(getAppData({ layout: props.layoutversion }));
	}, [dispatch, props.layoutversion]);

	return (
		<>
			{appReady ? (
				<IntlProvider locale={locale} messages={strings}>
					<>
						<Outlet context={{ ...getInitalModel() }} />
						<GeneralModal />
					</>
				</IntlProvider>
			) : (
				<div className="form-wrapper">
					<section className="form-placeholder">
						<Loading />
					</section>
				</div>
			)}
		</>
	);
};
